module.exports = __webpack_public_path__ + "media/images/Brent_Waters-0acc060d07b050f549f1bbc504e68098.jpg";